import MainCustomNavbar from "../../components/MainNavbar";
import image_0 from "../../assets/artist_pictures/marina/picture_2.webp";
import image_1 from "../../assets/artist_pictures/marina/picture_0.webp";
import image_2 from "../../assets/artist_pictures/marina/picture_1.webp";
import old_house from "../../assets/artist_pictures/marina/old_photo.webp";
import carrousel_0 from "../../assets/artist_pictures/marina/picture_3.webp";
import carrousel_1 from "../../assets/artist_pictures/marina/carrossel 2.webp";
import carrousel_2 from "../../assets/artist_pictures/marina/carrossel 3.webp";
import carrousel_3 from "../../assets/artist_pictures/marina/carrossel 4.webp";
import marina from "../../assets/artist_pictures/renata/picture_0.webp";
import frame_3 from "../../assets/artist_pictures/marina/frame_3.webp";
import performance from "../../assets/artist_pictures/marina/performance.webp";
import frame_4 from "../../assets/artist_pictures/marina/frame_4.webp";
import frame_1 from "../../assets/artist_pictures/marina/frame_1.webp";
import frame_2 from "../../assets/artist_pictures/marina/frame_2.webp";
import houses from "../../assets/components/houses.png";
// import casa_video from '../../assets/videos/marina/casa.mp4'
// import mulher_video from '../../assets/videos/marina/mulher.mp4'
// import pandemia_video from '../../assets/videos/marina/pandemia.mp4'
// import criacao_video from '../../assets/videos/marina/criacao.mp4'
// import arte_video from '../../assets/videos/marina/performance.mp4'
import { Col, Container, Row } from "react-bootstrap";
import React, { useEffect } from "react";
// @ts-ignore
import ProjectColors from "../../Colors";
import Arrow from "../../assets/components/side_arrow.png";
import { useNavigate } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
// @ts-ignore
import pdf_file from "../../assets/files/portfolio_marina.pdf";

import VideoPrefix from "../../VideoPrefix";

const casa_video = VideoPrefix + "marina/casa.mp4";
const mulher_video = VideoPrefix + "marina/mulher.mp4";
const pandemia_video = VideoPrefix + "marina/pandemia.mp4";
const criacao_video = VideoPrefix + "marina/criacao.mp4";
const arte_video = VideoPrefix + "marina/performance.mp4";

export default function ProfileMarina() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <MainCustomNavbar activeTab1={true} />

      <main
        role="main"
        style={{
          backgroundColor: ProjectColors.getInstance().isHighContrast
            ? ProjectColors.getInstance().Black
            : ProjectColors.getInstance().White,
        }}
      >
        <Container
          fluid
          style={{
            height: "100%",
            padding: 0,
          }}
        >
          {/*<Row*/}
          {/*    className={'align-items-center px-3'} style={{height: '100vh', width: '100vw'}}>*/}

          {/*    <Col xs={{span: 12}} md={{span: 12}}>*/}

          {/*        <h1 style={{fontFamily: 'Active Regular', fontWeight: 'bold', textAlign: 'center'}}>Ana Luíza</h1>*/}

          {/*    </Col>*/}
          {/*</Row>*/}

          <div
            style={{
              background: "url(" + image_0 + ")",
              backgroundSize: "cover",
              height: "100%",
              width: "100%",
              backgroundAttachment: "fixed",
              backgroundPosition: "75%",
            }}
          >
            <div style={{ height: "20vh", width: "100vw" }}></div>
            <Row
              style={{
                height: "90vh",
                width: "100vw",
                padding: 0,
              }}
            ></Row>
          </div>

          {/*<Row className={'align-items-center px-3'} style={{marginTop: '10vh',}}>*/}

          {/*    <Col xs={{span: 12}} md={{span: 12}}*/}
          {/*        // className={'d-flex align-items-center'}*/}
          {/*    >*/}

          {/*    </Col>*/}
          {/*</Row>*/}

          <Row style={{ marginTop: 10 }} className={"px-2"}>
            <Col xs={{ span: 12 }} md={{ span: 12, offset: 0 }}>
              <h5
                style={{
                  fontFamily: "Gotham",
                  textAlign: "justify",
                  textAlignLast: "justify",
                  color: ProjectColors.getInstance().White,
                  backgroundColor: ProjectColors.getInstance().isHighContrast
                    ? ProjectColors.getInstance().Black
                    : ProjectColors.getInstance().Orange,
                  padding: "20px",
                }}
              >
                Marina Bona tem 24 anos, nasceu, cresceu e vive em Brasília. É
                mulher, cis e bissexual. É artista, principalmente focada em
                dança. É graduada em Pedagogia pela Universidade de Brasília,
                onde aprofundou seus estudos em decolonialidade e novas
                alternativas para a educação. Trabalha como professora de dança,
                criadora e intérprete. Investiga o movimento desamarrado de
                aprisionamentos causados pelo silenciamento e pela padronização
                dos nossos corpos ao sul do equador.
              </h5>
              <div>
                <img src={image_1} alt="" className={"img-fluid"} />
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "5vw", marginBottom: 0 }} className={"px-2"}>
            <Col xs={{ span: 12 }} md={{ span: 6, offset: 3 }}>
              <h1
                style={{
                  fontFamily: "Active Regular",
                  fontWeight: "bold",
                  color: ProjectColors.getInstance().isHighContrast
                    ? ProjectColors.getInstance().White
                    : ProjectColors.getInstance().Orange,
                  textAlign: "justify",
                }}
              >
                "Casa pra mim sou eu e não existe espaço físico que represente a
                minha casa além de mim mesma".
              </h1>
            </Col>
          </Row>

          <Row style={{ marginTop: "5vw" }} className={"px-3"}>
            <Col xs={{ span: 12 }} md={{ span: 10, offset: 1 }}>
              <div>
                <h1
                  className={"mb-4"}
                  style={{
                    fontFamily: "Active Regular",
                    fontWeight: "bold",
                    color: ProjectColors.getInstance().isHighContrast
                      ? ProjectColors.getInstance().White
                      : ProjectColors.getInstance().Green,
                  }}
                >
                  Em casa
                </h1>
                <video
                  className={"img-fluid"}
                  style={{ justifyContent: "center", display: "flex" }}
                  controls
                  poster={frame_1}
                >
                  <source src={casa_video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Col>
          </Row>

          <div
            style={{
              backgroundColor: ProjectColors.getInstance().isHighContrast
                ? ProjectColors.getInstance().Black
                : ProjectColors.getInstance().DarkGreen,
              width: "100%",
              marginTop: "5vw",
              paddingTop: "5vw",
            }}
          >
            <Row style={{ marginTop: 10 }} className={"px-2"}>
              <Col xs={{ span: 12 }} sm={{ span: 10, offset: 1 }}>
                <Carousel
                  infiniteLoop
                  showIndicators={false}
                  showStatus={false}
                  autoPlay={false}
                >
                  {[
                    <div>
                      <img src={carrousel_0} />
                    </div>,
                    <div>
                      <img src={carrousel_1} />
                    </div>,

                    <div>
                      <img src={carrousel_2} />
                    </div>,

                    <div>
                      <img src={carrousel_3} />
                    </div>,
                    <div>
                      <img src={image_2} />
                    </div>,
                  ]}
                </Carousel>
              </Col>
            </Row>
            <Row
              style={{ marginTop: "5vw", paddingBottom: "5vw" }}
              className={"px-3"}
            >
              <Col xs={{ span: 12 }} md={{ span: 10, offset: 1 }}>
                <div>
                  <h1
                    className={"mb-4"}
                    style={{
                      fontFamily: "Active Regular",
                      fontWeight: "bold",
                      color: ProjectColors.getInstance().isHighContrast
                        ? ProjectColors.getInstance().White
                        : ProjectColors.getInstance().Green,
                    }}
                  >
                    Mulher e espaço doméstico
                  </h1>
                  <video
                    className={"img-fluid"}
                    style={{ justifyContent: "center", display: "flex" }}
                    controls
                    poster={frame_3}
                  >
                    <source src={mulher_video} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </Col>
            </Row>
          </div>

          <Row style={{ marginTop: "5vw" }} className={"px-2"}>
            <Col xs={{ span: 12 }}>
              <div
                className={"justify-content-center"}
                style={{ display: "flex" }}
              >
                <img
                  src={houses}
                  alt=""
                  style={{ height: "max(7vw, 70px)", backgroundColor: "white" }}
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: "5vw" }} className={"px-3"}>
            <Col xs={{ span: 12 }} md={{ span: 10, offset: 1 }}>
              <div>
                <h1
                  className={"mb-4"}
                  style={{
                    fontFamily: "Active Regular",
                    fontWeight: "bold",
                    color: ProjectColors.getInstance().isHighContrast
                      ? ProjectColors.getInstance().White
                      : ProjectColors.getInstance().Green,
                  }}
                >
                  Casa e pandemia
                </h1>
                <video
                  className={"img-fluid m-auto"}
                  style={{ justifyContent: "center", display: "flex" }}
                  controls
                  poster={frame_4}
                >
                  <source src={pandemia_video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "5vw" }} className={"px-2"}>
            <Col
              xs={{ span: 12 }}
              md={{ span: 4, offset: 4 }}
              className={"justify-content-center"}
            >
              <div
                style={{ display: "flex" }}
                className={"justify-content-center"}
              >
                <img src={old_house} alt="" className={"img-fluid"} />
              </div>
              <div>
                <div style={{ marginTop: 20 }}>
                  <p
                    style={{
                      fontSize: "max(1vw, 15px)",
                      textAlign: "right",
                      color: ProjectColors.getInstance().isHighContrast
                        ? ProjectColors.getInstance().White
                        : ProjectColors.getInstance().Black,
                    }}
                  >
                    {" "}
                    Casa de meu avô em Cajazeiras - Paraíba
                  </p>
                </div>
              </div>
            </Col>
          </Row>

          <Row
            style={{ marginTop: "5vw", marginBottom: "5vw" }}
            className={"px-3"}
          >
            <Col xs={{ span: 12 }} md={{ span: 10, offset: 1 }}>
              <div>
                <h1
                  className={"mb-4"}
                  style={{
                    fontFamily: "Active Regular",
                    fontWeight: "bold",
                    color: ProjectColors.getInstance().isHighContrast
                      ? ProjectColors.getInstance().White
                      : ProjectColors.getInstance().Green,
                  }}
                >
                  Processo artístico
                </h1>
                <video
                  className={"img-fluid m-auto"}
                  style={{ justifyContent: "center", display: "flex" }}
                  controls
                  poster={frame_2}
                >
                  <source src={criacao_video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Col>
          </Row>

          {/*<Row style={{marginTop: 80}} className={'px-2'}>*/}
          {/*    <Col xs={{span: 12}}>*/}
          {/*        <div>*/}
          {/*            <img src={image_5} alt="" className={'img-fluid'}/>*/}
          {/*        </div>*/}
          {/*    </Col>*/}

          {/*</Row>*/}

          <Row
            style={{
              paddingTop: "5vw",
              paddingBottom: "5vw",
              backgroundColor: ProjectColors.getInstance().isHighContrast
                ? ProjectColors.getInstance().Black
                : ProjectColors.getInstance().DarkGreen,
            }}
            className={"px-3"}
          >
            <Col xs={{ span: 12 }} md={{ span: 5, offset: 1 }}>
              <h1
                style={{
                  fontFamily: "Active Regular",
                  fontWeight: "bold",
                  color: ProjectColors.getInstance().isHighContrast
                    ? ProjectColors.getInstance().White
                    : ProjectColors.getInstance().Green,
                }}
              >
                Conheça os meus trabalhos
              </h1>
              <br />

              <a
                href="https://www.instagram.com/mmarinabona"
                style={{
                  color: ProjectColors.getInstance().isHighContrast
                    ? ProjectColors.getInstance().LightBlue
                    : ProjectColors.getInstance().Green,
                  fontSize: 28,
                }}
              >
                Instagram
              </a>
              <br />

              <a
                href="http://lattes.cnpq.br/0838849811012872"
                style={{
                  color: ProjectColors.getInstance().isHighContrast
                    ? ProjectColors.getInstance().LightBlue
                    : ProjectColors.getInstance().Green,
                  fontSize: 28,
                }}
              >
                Lattes
              </a>
              <br />

              <a
                href="https://www.youtube.com/channel/UCgBXJ3Y4q-UQZPaQ-prqJEg"
                style={{
                  color: ProjectColors.getInstance().isHighContrast
                    ? ProjectColors.getInstance().LightBlue
                    : ProjectColors.getInstance().Green,
                  fontSize: 28,
                }}
              >
                Youtube
              </a>
              <br />

              <a
                href={pdf_file}
                download
                style={{
                  color: ProjectColors.getInstance().isHighContrast
                    ? ProjectColors.getInstance().LightBlue
                    : ProjectColors.getInstance().Green,
                  fontSize: 28,
                }}
              >
                Portfólio
              </a>
            </Col>

            <Col xs={{ span: 12 }} md={{ span: 5 }}>
              <div>
                <video
                  className={"img-fluid m-auto"}
                  style={{ justifyContent: "center", display: "flex" }}
                  controls
                  poster={performance}
                >
                  <source src={arte_video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Col>
          </Row>

          <Row
            style={{
              backgroundImage: "url(" + marina + ")",
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: 500,
            }}
            className={"px-3"}
          >
            <Col xs={{ span: 12 }} className={"d-flex "}>
              <h1
                className={"my-4"}
                style={{
                  fontFamily: "Gotham Light",
                  marginLeft: 30,
                  fontSize: "70px",
                  color: "white",
                }}
              >
                Renata
                <img
                  src={Arrow}
                  width={50}
                  onClick={() => navigate("/artist/renata")}
                  alt={"Seta laranja apontando para a direita"}
                />
              </h1>
            </Col>
          </Row>
        </Container>
      </main>
    </>
  );
}
